/**
 * Progressive Discount Bar — Hot Sale México (Ellaz style)
 *
 * Updates the tiered-discount progress indicator in real time
 * as the cart changes. Listens for /cart/{add,change,update,clear}
 * mutations via fetch and XHR, plus common Shopify theme events.
 *
 * Pair with snippets/progressive-discount-bar.liquid.
 */
(function () {
  'use strict';

  // Per-tier message strings. Customize for your locale.
  var MESSAGES = {
    unlocked: 'Llegaste',
    locked: 'Te faltan {amount}'
  };

  // Dot positions on the track (percentages). Match the
  // pdb__dot[data-pdb-dot="N"] selectors in the snippet CSS.
  var DOT_POSITIONS = [16.67, 50, 83.33];

  function init() {
    if (!document.querySelector('[data-progressive-discount-bar]')) return;
    fetchAndRender();
    bindCartMutations();
  }

  function fetchAndRender() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // original_total_price is the pre-discount subtotal —
        // matches the threshold Shopify uses for the auto-discount.
        var subtotal = typeof cart.original_total_price === 'number'
          ? cart.original_total_price
          : (cart.items_subtotal_price || 0);
        renderAll(subtotal);
      })
      .catch(function () { /* silent */ });
  }

  function renderAll(subtotalCents) {
    var bars = document.querySelectorAll('[data-progressive-discount-bar]');
    Array.prototype.forEach.call(bars, function (bar) {
      renderBar(bar, subtotalCents);
    });
  }

  function renderBar(bar, subtotal) {
    var tiers;
    try {
      tiers = JSON.parse(bar.getAttribute('data-tiers'));
    } catch (e) {
      return;
    }
    if (!tiers || !tiers.length) return;

    // Fill bar (piecewise — fill reaches each dot exactly at unlock)
    var fill = bar.querySelector('[data-pdb-fill]');
    if (fill) fill.style.width = fillPct(subtotal, tiers) + '%';

    // Per-tier state
    tiers.forEach(function (tier, i) {
      var unlocked = subtotal >= tier.min;

      toggleClass(bar.querySelector('[data-pdb-col="' + i + '"]'), 'pdb__col--unlocked', unlocked);
      toggleClass(bar.querySelector('[data-pdb-dot="' + i + '"]'), 'pdb__dot--unlocked', unlocked);

      var statusEl = bar.querySelector('[data-pdb-status="' + i + '"]');
      if (statusEl) {
        toggleClass(statusEl, 'pdb__status--unlocked', unlocked);
        statusEl.textContent = unlocked
          ? MESSAGES.unlocked
          : MESSAGES.locked.replace('{amount}', formatMoney(tier.min - subtotal, bar));
      }
    });
  }

  function fillPct(subtotal, tiers) {
    if (subtotal <= 0) return 0;
    if (subtotal >= tiers[2].min) return 100;

    if (subtotal >= tiers[1].min) {
      var seg2 = (subtotal - tiers[1].min) / (tiers[2].min - tiers[1].min);
      return DOT_POSITIONS[1] + seg2 * (DOT_POSITIONS[2] - DOT_POSITIONS[1]);
    }
    if (subtotal >= tiers[0].min) {
      var seg1 = (subtotal - tiers[0].min) / (tiers[1].min - tiers[0].min);
      return DOT_POSITIONS[0] + seg1 * (DOT_POSITIONS[1] - DOT_POSITIONS[0]);
    }
    return (subtotal / tiers[0].min) * DOT_POSITIONS[0];
  }

  function toggleClass(el, cls, on) {
    if (!el) return;
    if (on) el.classList.add(cls);
    else el.classList.remove(cls);
  }

  function formatMoney(cents, bar) {
    var format = (bar && bar.getAttribute('data-money-format')) ||
      (window.theme && window.theme.moneyFormat) ||
      '${{amount_no_decimals}}';

    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format)
        .replace(/\.00\b/, '')
        .replace(/,00\b/, '');
    }
    // Fallback — peso-style formatting
    return '$' + Math.round(cents / 100).toLocaleString('es-MX');
  }

  function bindCartMutations() {
    // Intercept fetch for cart endpoints
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function () {
        var url = typeof arguments[0] === 'string'
          ? arguments[0]
          : (arguments[0] && arguments[0].url) || '';
        var promise = origFetch.apply(this, arguments);
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          promise.then(function () { setTimeout(fetchAndRender, 60); });
        }
        return promise;
      };
    }

    // Intercept XHR for older theme code paths
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener('load', function () {
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
          setTimeout(fetchAndRender, 60);
        }
      });
      return origOpen.apply(this, arguments);
    };

    // Common theme events (Mode and most Shopify 2.0 themes)
    var events = [
      'cart:updated', 'cart:refresh', 'cart:change', 'cart:build',
      'cart.requestComplete', 'ajaxProduct:added', 'cart:open'
    ];
    events.forEach(function (evt) {
      document.addEventListener(evt, fetchAndRender);
      window.addEventListener(evt, fetchAndRender);
    });

    // jQuery events (Mode uses jQuery)
    if (window.jQuery) {
      window.jQuery(document).on(
        'cart.requestComplete ajaxCart.afterCartLoad cart:updated cart:refresh',
        fetchAndRender
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
